import React from 'react';
import { Panel, Section, Sub, Badge } from './GrowthBits';
import { SCENARIOS, SAL, RECRUIT, funnel, teamNeed, budget, revenue, money, num } from './growthData';

export function ScenariosTab({ S }) {
  const a = S.a;
  const rows = SCENARIOS.map((t) => {
    const f = funnel(a, t), need = teamNeed(a, f), team = need.assoc + need.broker + need.assessor + need.settle;
    const rev = revenue(a, f), cost = budget(a, f) + (need.assoc * SAL.assoc + need.broker * SAL.broker + need.assessor * SAL.assessor + need.settle * SAL.settle) / 12;
    return { t, f, team, rev, cost, mk: budget(a, f) };
  });
  const max = Math.max(...rows.map((r) => r.rev - r.cost));
  return (
    <div data-testid="egt-tab-scenarios">
      <Section eyebrow="Part 03 · Scenario Planning" title="Model $20M to $60M+ a month" lead="Each scenario uses the same editable assumptions from Reverse-Engineer. Figures are forecasts, clearly distinct from actual results." />
      <Sub note={`Highlighted row = your current target ($${a.target}M)`}>Scenarios</Sub>
      <Panel testid="egt-scenario-table">
        <div className="gpj-reg-wrap"><table className="gpj-reg">
          <thead><tr><th>Scenario</th><th className="r">Leads/mo</th><th className="r">Lodge/mo</th><th className="r">Mktg $/mo</th><th className="r">Team</th><th className="r">Est rev/mo</th><th className="r">Est cost/mo</th><th style={{ minWidth: 200 }}>Est contribution</th></tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.t} className={r.t === a.target ? 'cur' : ''} style={{ cursor: 'default' }} data-testid={`egt-scen-${r.t}`}>
              <td><strong>${r.t}M</strong><small>per month</small></td><td className="r">{num(r.f.leads)}</td><td className="r">{num(r.f.lodge)}</td><td className="r">{money(r.mk)}</td><td className="r">{r.team}</td><td className="r"><span className="ok">{money(r.rev)}</span></td><td className="r">{money(r.cost)}</td>
              <td><div style={{ display: 'flex', alignItems: 'center', gap: 10 }}><div className="gpj-track" style={{ flex: 1 }}><div className="gpj-fill" style={{ width: `${Math.max(4, ((r.rev - r.cost) / max) * 100)}%` }} /></div><strong style={{ minWidth: 56, textAlign: 'right' }}>{money(r.rev - r.cost)}</strong></div></td>
            </tr>
          ))}</tbody>
        </table></div>
      </Panel>
      <div className="egt-note">Forecasts, not actuals. Team = associates + brokers + assessors + settlements. Contribution = est. revenue minus est. marketing and staff cost; indicative only.</div>
    </div>
  );
}

export function RecruitTab() {
  return (
    <div data-testid="egt-tab-recruit">
      <Section eyebrow="Part 04 · Recruitment & Team Expansion" title="Who we hire, when and why" lead="Recruitment is triggered by operational demand, not dates. The order protects our separation of duties: associates own conversion, CSM owns pipeline, Credit owns assessment." />
      <Sub>Hiring roadmap</Sub>
      <Panel testid="egt-recruit-table">
        <div className="gpj-reg-wrap"><table className="gpj-reg">
          <thead><tr><th style={{ width: 40 }}>#</th><th>Role</th><th>Department</th><th>Trigger</th><th>Planned</th><th className="r">Est. cost/yr</th><th>Onboarding</th><th>Status</th></tr></thead>
          <tbody>{RECRUIT.map((r) => (
            <tr key={r.role} style={{ cursor: 'default' }}><td><span className="gpf-n" style={{ width: 32, height: 32, fontSize: 14, '--tone': 'var(--blue)' }}>{r.pri}</span></td><td><strong>{r.role}</strong></td><td>{r.dept}</td><td><small style={{ fontSize: 12.5, color: 'var(--fg-2)' }}>{r.trigger}</small></td><td>{r.when}</td><td className="r">{money(SAL[r.sal])}</td><td>{r.onb}</td><td><Badge tone="grey">Planned</Badge></td></tr>
          ))}</tbody>
        </table></div>
      </Panel>
      <div className="egt-note">Annual costs are planning estimates (onshore vs offshore delivery differs), not individual salaries.</div>
    </div>
  );
}
